import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveAndPersistVisitorSlug } from './visitorIdentity';

function track(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
}

export default function PageTracking() {
    const location = useLocation();

    useEffect(() => {
        const visitorSlug = resolveAndPersistVisitorSlug(location.search);

        track('page_view_custom', {
            visitor_slug: visitorSlug || 'unknown',
            page_path: `${location.pathname}${location.search}`,
            page_title: document.title,
            page_location: window.location.href
        });
    }, [location.pathname, location.search]);

    return null;
}
